import React, { Component } from 'react';

export class TextArea extends Component {
    titleRef = null;
    constructor(props) {
        super(props);
        this.state = {
            title: "Description",
            value: '',
            editTitle: false,
            isRequired: true,
            name: 'question',
            id: 'question',
            notice: '',
            placeHolder: '',
            errorMessage: 'This field is required.',
            validations: [],
            isActive: false
        }
        this.titleRef = React.createRef();
    };

    getContent = () => {
        const { id, name, title, isRequired, placeHolder, errorMessage, notice, validations, value } = this.state;
        return {
            id,
            name,
            value,
            title,
            isRequired,
            placeHolder,
            errorMessage,
            notice,
            validations,
            type: this.props.type
        };
    };

    onClickEditTitle = () => {
        this.setState({
            editTitle: true
        });
        setTimeout(() => {
            this.titleRef.current.focus();
        });
    };

    handleStateChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
        this.setProperties({ [name]: value });
    };

    onFocusOutTitle = () => {
        this.setState({
            editTitle: false
        });
    };

    toggleIsRequired = (e) => {
        e.preventDefault();
        this.setState({
            isRequired: !this.state.isRequired
        });
        this.setProperties({ isRequired: !this.state.isRequired });
    };

    setProperties = (sendData) => {
        const { title, isRequired, placeHolder, name, notice, id, errorMessage, validations, value } = this.state;
        const { type } = this.props;
        const properties = {
            type,
            title: title,
            id: id,
            name: name,
            value: value,
            notice: notice,
            isRequired: isRequired,
            errorMessage: errorMessage,
            placeHolder: placeHolder,
            validations: validations,
            ...sendData
        };
        this.props.setPropertiesData(properties, this.props.location);
        this.setIsActive(true);
    }

    changeProperties = (formContent) => {
        const { title, placeHolder, name, notice, id, errorMessage, isRequired, validations, value } = formContent;
        this.setState({
            title: title,
            placeHolder: placeHolder,
            name: name,
            value: value,
            id: id,
            notice: notice,
            errorMessage: errorMessage,
            isRequired: isRequired,
            validations: validations,
        });
        this.props.setPropertiesData(formContent, this.props.location);
    };

    onClickDelete = () => {
        this.props.onClickDelete(this.props.location);
    };

    setIsActive = (isActive) => {
        this.setState({
            isActive
        });
    };

    render() {
        const { title, editTitle, isRequired, notice, errorMessage, placeHolder, isActive, value } = this.state;
        return (
            <div className="col-4 question-container-inner">
                <div className={`pb-3 question-heading ${editTitle ? 'd-none' : 'd-block'}`}>
                <strong className="d-inline-block">
                        {title}
                    </strong>
                    <div className="float-right">
                        <button onClick={this.onClickEditTitle} className="btn px-1 py-0">
                            <i className="fal fa-edit"></i>
                        </button>
                    </div>
                </div>
                <div className={`pb-3 question-heading ${editTitle ? 'd-block' : 'd-none'}`}>
                    <input type="text" value={title} name="title" onChange={this.handleStateChange} onBlur={this.onFocusOutTitle} ref={this.titleRef} />
                    {
                        isRequired && <span>&nbsp;*</span>
                    }
                </div>
                <div className="form-group">
                    <textarea className="form-control" value={value} name="value" rows={5} placeHolder={placeHolder} onChange={this.handleStateChange}></textarea>

                </div>
            </div>
        );

    }
}
